import { render } from "./CometChatConversationListItem.vue?vue&type=template&id=312c3dba&scoped=true"
import script from "./CometChatConversationListItem.vue?vue&type=script&lang=js"
export * from "./CometChatConversationListItem.vue?vue&type=script&lang=js"

import "./CometChatConversationListItem.vue?vue&type=style&index=0&id=312c3dba&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312c3dba"]])

export default __exports__